export default __webpack_public_path__ + "104833d2309018a616895d7969a7dcdc.png";